import venFlowsLogo from "../assets/venflows-logo.png";
import vpayLogo from "../assets/vpay-logo.png";
import scrapLogo from "../assets/scrap-logo.png";
import venAgentsLogo from "../assets/venagents-logo.png";

const platforms: Platform[] = [
  {
    name: "scrap",
    id: `${process.env.REACT_APP_SCRAP_APP_ID}`,
    logo: scrapLogo,
    "prod-url": "https://www.scrap-bh.com",
    "dev-url": "https://www.scrap-bh.com",
    "local-url": "http://localhost:3000",
    is_default: false,
  },
  {
    name: "venAgents",
    id: `${process.env.REACT_APP_VEN_AGENTS_APP_ID}`,
    logo: venAgentsLogo,
    "prod-url": "https://venagents.com",
    "dev-url": "https://ven-agents.venlabs.link",
    "local-url": "http://localhost:3000",
    is_default: true,
  },
  {
    name: "venFlows",
    id: `${process.env.REACT_APP_VEN_FLOWS_APP_ID}`,
    logo: venFlowsLogo,
    "prod-url": "https://www.venflows.com",
    "dev-url": "https://pos.venlabs.link",
    "local-url": "http://localhost:3000",
    is_default: false,
  },
  {
    name: "vpay",
    id: `${process.env.REACT_APP_VPAY_APP_ID}`,
    logo: vpayLogo,
    "prod-url": "https://venpays.com",
    "dev-url": "https://vpay.venlabs.link",
    "local-url": "http://localhost:3000",
    is_default: false,
  },
];

export interface Platform {
  name: string;
  id: string;
  logo: string;
  "prod-url": string;
  "dev-url": string;
  "local-url": string;
  is_default: boolean;
}

export const getPlatform = (platform: string): Platform => {
  const requestedPlatform = platforms.find((p) => p.id === platform);

  if (!requestedPlatform) {
    // Find and return the default platform
    const defaultPlatform = Object.values(platforms).find((p) => p.is_default);

    if (!defaultPlatform) {
      throw new Error("No default platform configured");
    }

    return defaultPlatform;
  }

  return requestedPlatform;
};

/**
 * Gets the platform from the URL query parameter
 * Example URL: something.com?platform=ven_flows
 * @returns The platform object based on the URL parameter, or the default platform if not found
 */
export const getPlatformFromUrl = (): Platform => {
  const urlParams = new URLSearchParams(window.location.search);
  const platformParam = urlParams.get("platform");

  if (!platformParam) {
    return getPlatform(""); // This will return the default platform
  }

  return getPlatform(platformParam);
};
